import { ReactNode, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import styled from 'styled-components';
import { Button } from '@salutejs/sdds-insol';
import { Typography } from '@/shared/ui/Typography';
import Logo from '@/shared/assets/lk/lkLogo.svg?react';
import { setCookie } from '@/shared/lib/utils/setCookie';
import { useLogin, useLogout, useRegister } from '@/entities/User';
import { useSendLogLogin } from '@/pages/AuthPage/query/useSendLogLogin';
import cls from './EmptyData.module.scss';

const BackButton = styled(Button)`
    background-color: #8a959d;
`;
const ChangeUserButton = styled(Button)`
    background-color: #21ba72;
`;

type Props = {
    description: ReactNode | string;
    subDescription?: ReactNode | string;
    title: string;
};

export const EmptyData = ({ title, description, subDescription }: Props) => {
    const [searchParams] = useSearchParams();

    const { mutate: logLogin } = useSendLogLogin();
    const { mutate: login } = useLogin();
    const { mutate: register, isPending: isRegisterPending } = useRegister();
    const { mutate: logout, isPending: isLogoutPending } = useLogout({
        onSuccess: () => {
            setCookie('search_params', searchParams.toString(), 1);
            login();
        },
    });

    useEffect(() => {
        logLogin();
    }, []);

    return (
        <div className={cls.wrapper}>
            <div className={cls.container}>
                <div className={cls.logoWithTitle}>
                    <Logo className={cls.logo} />
                    <Typography className={cls.title} as="h5" variant="h5_bold">
                        {title}
                    </Typography>
                </div>
                <Typography as="h6" variant="h6">
                    {description}
                </Typography>
                {subDescription && (
                    <Typography as="h6" variant="h6">
                        {subDescription}
                    </Typography>
                )}
                <div className={cls.buttons}>
                    <ChangeUserButton
                        size="xl"
                        view="dark"
                        type="button"
                        isLoading={isRegisterPending || isLogoutPending}
                        stretch
                        onClick={() => {
                            logout();
                        }}
                    >
                        <span className="SBSansText">Сменить пользователя</span>
                    </ChangeUserButton>
                    <BackButton
                        size="xl"
                        view="dark"
                        type="button"
                        isLoading={isRegisterPending || isLogoutPending}
                        stretch
                        onClick={() => {
                            setCookie('search_params', searchParams.toString(), 1);
                            register();
                        }}
                    >
                        <span className="SBSansText">Подать заявку на оформление</span>
                    </BackButton>
                </div>
            </div>
        </div>
    );
};
